export default {
    // title 
    titleMarketUpdates: '市場動態',
    titleTrendingCompanies: '熱門公司',
    titleInvite: "邀請並獲得獎勵",
    titleOnboarding: "入門工具",

    // trending companies

    // invite
    forReferrals: "推薦人：",
    inviteBtn: '邀請',
    copyLink: '複製連結',
    shareYourReferralLink: '分享您的推薦連結或輸入電子郵件邀請他人。 加入即可獲得獎勵！',
    forTeamInvites: "對於團隊邀請（獲得信用點數）：",
    assignTeamInvites: "指定團隊邀請",
    lookingToGrowYourTeam: "想發展你的團隊嗎？ 每次有人加入時，分配邀請並開始賺取信用點數！",
    addMultipleAddresses: "添加多個用逗號分隔的地址",
    greatProgress: "進步很大！ 繼續邀請解鎖全部{count}信用點數。",
    startInviting: '開始邀請並獲得高達 {count} 個信用點數！',
    allSet: "準備就緒！ 您已獲得 {count} 信用點數，感謝您的邀請！",

    // custom insight
    addYourOwnCustomInsights: "添加您自己的自定義見解",
    companyKeyMilestones: "公司的關鍵里程碑",
    listMajorCompetitors: "列出同行業的主要競爭對手",
    analyzeMarketPresence: "分析公司的市場佔有率",
    poweredByAi: "由Ai提供技術支援",
    grantedUponCompletion: '{count} 信用點數將在完成後獲得',
    granted_complete: '已獲得 {count} 信用點數獎勵！',

    // ai
    meetRonnaAi: "認識RonnaAi-您的智慧商務助理",
    askAnything: "問點什麼...",
    askQuestionsExploreStrategies: '提出問題，探索策略，或獲得為您量身定制的即時見解。',
    limitedView: "受限視圖",
    viewFullCompanyDetails: "查看完整的公司詳細資訊",
    recentThreads: "最近搜索",
    recentlyViewed: "最近查看",
    companyAndWebsite: "公司/網站",
    noResultsAskAi: "沒有結果？ 向RonnaAI詢問相關資訊",
    allSearchResultsFor: "{count} 的所有搜索結果",
    searchForAnything: "搜索任何東西...",
    pressEnter: "按 ENTER",
    askRonnaAI: "詢問RonnaAI：",
    clickToChatWithRonnaAI: "點擊與RonnaAI聊天，瞭解更多詳情",
    useRonnaAIToExploreBusinessDirectories: "使用RonnaAI即時探索業務目錄、見解等。",
    ronnaAI: "RonnaAI",
    findSearchHistory: "尋找搜索歷史",
    Today: '今天',
    "7 Days": "7天內",
    '30 Days': "更多",
    deleteRecord: "删除記錄",
    newChat: "創建新對話",
    aiTabAnswer: "回答",
    aiTabCompanies: "公司",
    aiTabSources: "資源",
    processingYourRequest: "正在處理您的請求...",
    thinkingDeeply: "深入思考中",
    generatingAPlan: "生成計畫中",
    noHistoryYet: "暫無歷史",

    // advertisement
    targetLocation: "目標投放區域",
    open_ad: "開啟廣告",
    ad_type_label: {
      text: "文字素材",
      image: "圖片素材",
      video: "影片素材",
      carousel: "輪播素材",
      other: "素材",
    },
    est_impressions: "預估曝光量",
    ads: "廣告",

    // expansion signals (Phase 1)
    expansion: {
        companyFacts: {
          duplicateProfileNotice: "這是重複的公司檔案。",
          viewCurrentProfile: "查看目前檔案",
          duplicateProfileTip: "此檔案為重複項目，請開啟目前檔案",
        },
        jobsInsights: {
            heading: "招聘動態",
            windowReadout: "最近 {n} 天",
            windowHint: "統計該期間內的在徵職位",
            kpiOpen: "在徵職位",
            kpiPosted: "新發布職缺",
            openSub: "共 {n} 個在徵",
            kpiPace: "招聘節奏",
            kpiTopFunction: "主要職能",
            kpiMarkets: "涵蓋地區",
            newSub: "新增 {n}",
            trendVsPrior: "較上期",
            marketShare: "{pct}% {place}",
            nRoles: "{n} 個職位",
            momentumLabel: "招聘走勢",
            velAccel: "加速中",
            velSlow: "放緩中",
            velSteady: "平穩",
            mover: "{flag} {place} — 過去一個月 {n} 個職位",
            moverSenior: "{flag} {place} — 過去一個月 {n} 個職位，多為 {tier}",
            moverNew: "· 新市場",
            exploreLabel: "探索",
            exploreHint: "點擊長條，看職能、地區與職級如何關聯",
            showingOf: "{total} 個中的 {n} 個",
            clearAll: "清除",
            listFilteredBy: "篩選條件：",
            notClassified: "{n} 個未分類",
            openListTitle: "新發布職缺",
            openListNote: "發布於 · {window}",
            leadTopFunction: "{label} 居首——{count} 個職位",
            leadTopLocation: "{pct}% 在 {place}",
            tier_executive: "高階主管",
            tier_director: "總監",
            tier_manager: "經理",
            tier_senior: "資深",
            tier_junior: "初級",
            byFunction: "依職能",
            byLocation: "依地區",
            bySeniority: "依職級",
            thisCompany: "該公司",
            narrFast: "{company} 正在快速擴張——最近 {days} 天發布了 {n} 個職位，較上期成長 {pct}%。",
            narrUp: "{company} 正在積極招聘——最近 {days} 天新增 {n} 個職位，較上期成長 {pct}%。",
            narrSteady: "{company} 招聘維持平穩——最近 {days} 天發布 {n} 個職位，與上期持平。",
            narrDown: "{company} 招聘有所放緩——最近 {days} 天發布 {n} 個職位，較上期下降 {pct}%。",
            narrQuiet: "{company} 有 {open} 個在徵職位，但近期發布活動較少。",
            narrMix: "以 {fn} 為主，集中在 {loc}。",
            narrMixSenior: "以 {fn} 為主，集中在 {loc}，其中 {pct}% 為管理層職位。",
            loadError: "無法載入招聘洞察",
            retry: "重試",
            none: "—",
        },
        adsInsights: {
            eyebrow: "廣告動態",
            openListTitle: "進行中的廣告",
            lead: "在 {markets} 個市場投放 {n} 個廣告",
            kpiActive: "進行中廣告",
            kpiMarkets: "涵蓋市場",
            kpiTopChannel: "主要渠道",
            kpiTopFormat: "主要格式",
            leadReach: "觸及高達 {reach}",
            kpiMomentum: "投放勢頭",
            windowSub: "近 {n} 天",
            trendVsPrior: "較上期",
            sparkLabel: "廣告投放",
            moreInsights: "更多洞察",
            lessInsights: "收合洞察",
            byReach: "依觸及量（曝光）",
            reach_lt_1k: "<1千",
            reach_1k_10k: "1千–1萬",
            reach_10k_50k: "1萬–5萬",
            reach_50k_100k: "5萬–10萬",
            reach_100k_500k: "10萬–50萬",
            reach_500k_1m: "50萬–100萬",
            reach_1m_plus: "100萬+",
            reachPeak: "峰值 {peak}",
            byMarket: "依目標市場",
            byChannel: "依渠道",
            byFormat: "依格式",
            byPlacement: "依版位",
            exploreLabel: "探索",
            exploreHint: "點擊長條 — 查看觸及、市場與管道的關聯",
            exploringOf: "正在探索最近 {total} 筆中的 {n} 筆",
            showingOf: "{total} 則廣告中的 {n} 則",
            clearAll: "清除",
            leadTopMarket: "{pct}% 投放 {place}",
            leadTopChannel: "{pct}% 透過 {channel}",
            noImpression: "這些廣告暫無曝光量資料",
            noImpressionN: "{n} 則無曝光量資料",
            noMarket: "暫無目標市場資料",
            noMarketN: "{n} 則無目標市場",
            marketLed: "主要為 {place}",
            creatives: "近期素材",
            nCampaigns: "{n} 則廣告",
            loadError: "無法載入廣告洞察",
            retry: "重試",
            none: "—",
        },
        newsInsights: {
            eyebrow: "媒體報導",
            lead: "過去 {days} 天 {n} 次提及",
            kpiMentions: "報導數",
            kpiMomentum: "報導勢頭",
            kpiPositive: "擴張訊號",
            kpiRisk: "風險訊號",
            kpiTopics: "主題",
            kpiSources: "來源",
            ledBy: "以 {x} 為主",
            windowSub: "近 {n} 天",
            trendVsPrior: "較上期",
            sparkLabel: "報導量",
            fundingLatest: "最新募資",
            moreInsights: "更多洞察",
            lessInsights: "收合洞察",
            byTopic: "依主題",
            byMarket: "依市場",
            openListTitle: "近期新聞",
            exploreHint: "點擊主題篩選列表",
            loadError: "無法載入媒體洞察",
            retry: "重試",
            none: "—",
        },
        pitch: {
            headline: "Pubrio · 發掘正進軍新市場的企業。",
            body: "每天有數千家公司進入新市場。搶先成為他們的第一通電話,而非最後一通。",
            dismiss: "關閉",
        },
        kpi: {
            title: "關鍵擴張指標",
            mostActiveMarket: "最活躍市場",
            yourFocus: "您關注的市場",
            companiesInWindow: "{n} 家具新訊號 · {window}",
            bestToContact: "最佳聯繫時機",
            inExpandingStage: "處於拓展階段",
            movingUnusuallyFast: "異常快速發展中",
            aheadOfPace: "領先於一般進度",
            hot: "熱門",
            newActivity: "新動態訊號",
            activeMarkets: "活躍市場",
            thisWeek: "本週",
            last30Days: "近 30 天",
            movementHeadline: "本期新動態",
            movementHint: "涵蓋 {total} 個市場中的 {active} 個",
            // Tile 2-4 hint suffixes — GLOBAL mode appends a country chip,
            // SELECTED mode reuses tile 1's focus country and drops the chip.
            hintOfMarket: "佔市場 {rate}",
            hintOfFocus: "佔 {country} 公司的 {rate}",
            hintAheadOfPaceGlobal: "{rate} 領先進度",
            hintAheadOfPaceFocus: "{country} 中有 {rate} 領先進度",
            hintNewThisWeekGlobal: "本週新增 {rate}",
            hintNewThisWeekFocus: "{country} 本週新增 {rate}",
            // Empty state for SELECTED mode when the picked country has no data
            // in the active date window.
            noDataInWindow: "此期間內尚無訊號",
        },
        competitive: {
            heading: "競爭擴張對比",
            subCurated: "{name} 的海外擴張與其競爭對手的對比",
            comparingAgainst: "對比對象",
            addCompetitor: "新增競爭對手",
            addSearching: "搜尋中…",
            addEmpty: "找不到公司",
            removeCompetitor: "移除",
            takeawayLead: "在{metric}方面，{name} 領先於 {n} 家競爭對手。",
            takeawayRank: "在{metric}方面，{name} 在 {total} 家競爭對手中排名第 {rank}。",
            colCompany: "公司",
            colMarket: "市場",
            colActiveMarkets: "市場",
            colNewMarkets: "新市場",
            colMomentumPct: "動能",
            colSignalCount: "活躍度",
            colExpansionScore: "擴張評分",
            colWindowExpansionScore: "近期評分",
            colIndustry: "產業",
            colCountry: "總部",
            colEmployees: "員工數",
            colFounded: "成立年份",
            colWebsite: "網站",
            colTopMarket: "首要擴張市場",
            colNewestMarket: "最新進入",
            colScaling: "規模化",
            colPipeline: "儲備市場",
            colMatch: "匹配度",
            columns: "欄位",
            columnsHint: "新增比較欄位",
            fieldsGroupExpansion: "擴張指標",
            fieldsGroupCompany: "公司資訊",
            you: "本公司",
            openCompany: "開啟公司",
            pendingHint: "擴張資料載入中",
            empty: "尚無具備擴張資料的競爭對手。",
            cellSignals: "{n} 個訊號",
            hoverHint: "將滑鼠移到市場指標上即可查看背後的實際國家/地區。",
            coverageTitle: "市場覆蓋",
            coverageSub: "各競爭對手在哪些市場、深入到何種階段 — {total} 個市場中有 {gaps} 個是他們已進入而你尚未進入的。",
            covAll: "全部",
            covGaps: "空白",
            covYours: "本公司",
            watch: "關注市場",
            fieldCaption: "長條顯示相對規模；迷你圖為各競爭對手的每週活躍度走勢。",
            legendStage: "顏色 = 階段",
            legendRecent: "近期活躍",
            covYouHint: "底色 = 本公司",
            coverageCount: "{total} 家中有 {n} 家在場",
            cellTypes: "訊號類型",
            cellSince: "首次發現",
            cellActive: "{t}活躍",
            sortLabel: "市場排序",
            covSortCoverage: "覆蓋",
            covSortRecent: "最近",
            searchMarket: "尋找市場…",
            noMarkets: "沒有符合篩選的市場。",
        },
        verdict: {
            newMarkets: "新市場",
            momentum: "動能",
            expansionScore: "擴張評分",
            vsPrior: "對比上一期",
            noneThisPeriod: "本期無",
            signalsLabel: "訊號",
            scoreVeryStrong: "非常強勁",
            scoreStrong: "強勁",
            scoreDeveloping: "發展中",
            scoreEarly: "早期階段",
        },
        summary: {
            heading: "全球擴張",
            subheading: "這家公司在哪裡營運,以及正在進軍的市場。",
            subheadingCount: "橫跨全球 {n} 個市場 — 從起點到如今正在成長的地方。",
            founded: "成立於",
            employees: "名員工",
            markets: "市場",
            marketsHintFrom: "自 {hq} 擴張",
            marketsHintWorldwide: "全球佈局",
            furthestStage: "最遠階段",
            movingNow: "目前推進中",
            movingNowHint: "近 90 天內有所推進",
            upToMarkets: "最多 {n} 個市場",
            stages: "階段",
            loading: "載入擴張資料…",
            empty: "尚未追蹤到這家公司的擴張訊號。",
            emptyTitle: "正在聆聽擴張訊號",
            emptyDetail: "目前尚無資料可顯示。當 {company} 在新市場招募、發布新聞與投放廣告時,訊號將會在此呈現。",
            thisCompany: "這家公司",
            established: "已建立",
            establishedTip: "已在這些市場營運 — 無新的擴張活動",
            establishedNote: "{company} 已在 {n} 個市場建立業務 — 此時間範圍內無新的擴張活動。",
            errorTitle: "無法連接訊號服務",
            errorDetail: "我們目前無法載入擴張資料。這通常是暫時性問題 — 請再試一次。",
            retry: "重試",
            tipMarket: "依市場篩選",
            tipDate: "變更時間範圍",
            tipStage: "依生命週期階段篩選",
            tipExport: "匯出這家公司",
            tipClear: "清除所有篩選",
            insight: "橫跨 {total} 個市場 · 於 {year} 年首次進入 {market} · 近 90 天內有 {moving} 個推進",
            insightNoFirst: "橫跨 {total} 個市場 · 近 90 天內有 {moving} 個推進",
            timeAll: "所有時間",
            time12m: "12個月",
            time6m: "6個月",
            time3m: "3個月",
            filterFocus: "鎖定市場",
            filterAll: "所有市場",
            filterMore: "+{n} 個",
            filterClear: "清除",
            filterShowing: "{total} 個市場中的 {n} 個",
        },
        pulse: {
            heading: "活動脈動",
            windowHint: "時間範圍依上方日期篩選",
            catHiring: "招募",
            catMarketing: "行銷與公關",
            catProduct: "產品與技術",
            catFootprint: "據點佈局",
            catPartners: "合作夥伴",
            leadMore: "{type} +{n}",
            leadNone: "無活動",
            trendNew: "新增",
            trendSteady: "穩定",
            trendEnded: "已結束",
            recentEvents: "近期動態",
            headcountReduction: "裁員",
            postingCount: "{n} 個相同職缺的職位",
            loadMore: "載入更多",
            loadingMore: "載入中…",
            viewSource: "檢視來源",
            via: "透過 {source}",
            sourceNews: "新聞",
            sourceJobs: "職缺",
            sourceAds: "廣告",
            focusMarket: "於動態中鎖定 {market}",
            drillSub: "{n} 個訊號 · {types} 種類型活躍中",
            hQuiet: "所有市場皆無動靜 — 此期間內無任何訊號。",
            hNew: "新的{category}活動 — 剛出現 {n} 個新訊號。",
            hRising: "{category}正在加速 — 較上一期成長 {pct}%。",
            hTop: "在{category}最為活躍 — 由{type}領頭({n} 個訊號)。",
            hTopPlain: "在{category}最為活躍 — {n} 個訊號。",
        },
        portfolio: {
            heading: "擴張組合",
            markets: "個市場",
        },
        timeline: {
            heading: "市場進入時間軸",
            subEntry: "這家公司進入各市場的順序 — 從最早到最新",
            subMomentum: "依最近階段動能排序的市場",
            byEntry: "依進入順序",
            byMomentum: "依動能",
            signals: "個訊號",
            signalTypes: "種訊號類型",
            stageUp: "階段升級 · {when}",
            stageUpToday: "階段升級 · 今天",
            now: "現在",
            firstSignal: "偵測到首個訊號",
            longEstablished: "長期經營",
            ordinalEntered: "進入的第 {ord} 個市場",
            trackedDays: "已追蹤 {n} 天",
            trackedMonths: "已追蹤 {n} 個月",
            trackedYears: "已追蹤 {n} 年",
            confidence: "{n}% 可信度",
            empty: "沒有符合此篩選的市場。",
            showAll: "顯示全部 {n} 個",
            showLess: "顯示較少",
        },
        feed: {
            signalsIn: "訊號所在地",
            signals: "個訊號",
            via: "透過 {source}",
            reached: "已達到 {stage}",
            firstSignal: "首個訊號",
            show: "顯示 {n}",
            hide: "隱藏",
            empty: "此市場尚未偵測到任何訊號。",
            emptyHint: "請在地圖上選擇其他市場,或擴大時間範圍以呈現更多活動。",
            pickTitle: "選擇市場",
            pickHint: "在時間軸上選擇任一市場以探索其訊號。",
            noMarketsTitle: "目前無市場可顯示",
            noMarketsHint: "調整篩選條件以重新顯示市場。",
            loadMore: "載入更多訊號",
        },
        journey: {
            wentFirst: "最先進入",
            wentFirstSub: "依其擴張的順序",
            movingNow: "目前推進中",
            movingNowSub: "最近階段動能",
            none: "尚無擴張市場",
            showAll: "顯示全部 {n} 個",
            showLess: "顯示較少",
        },
        dateRange: {
            today: "今天",
            last7: "近 7 天",
            last30: "近 30 天",
            last90: "近 90 天",
            last12m: "近 12 個月",
            customLabel: "自訂範圍",
            startPlaceholder: "起始",
            endPlaceholder: "結束",
        },
        countryChips: {
            title: "市場",
            subtitle: "選擇國家以鎖定儀表板範圍",
            ariaLabel: "已追蹤市場",
            addMarket: "新增市場",
            compare: "比較",
            more: "更多",
            remove: "移除市場",
            comparingNMarkets: "正在比較 {n} 個市場 | 正在比較 {n} 個市場",
            pickMarketsToCompare: "點擊市場進行比較",
            multiSelectOff: "多選",
            multiSelectOnN: "多選 · {n}",
        },
        mapMode: {
            toggleAriaLabel: "地圖檢視模式",
            global: "所有市場",
            intoCountry: "流入",
            outgoing: "對外擴張",
            corridorHint: "正在顯示 從 → 到 的走廊 — 點選以清除「到」一側",
            backToOverview: "返回總覽",
            // TODO: translate (placeholders copied from en.js)
        },
        find: {
            heading: "你在尋找什麼？",
            placeholderHero: "描述一個市場——例如：正在擴張進入德國的 AI 公司",
            placeholderDocked: "描述一個市場",
            submit: "尋找",
            clear: "清除",
            hintPrefix: "試試：",
            examples: [
                "擴張進入美國的金融科技公司",
                "積極擴張進入德國的 AI 公司",
                "正在拓展至英國的公司",
                "擴張進入日本的 AI 公司",
                "擴張進入法國的德國公司",
                "正在拓展至新加坡的公司",
            ],
            noMatch: "無法將其對應為篩選條件。請嘗試指定市場、階段或產業。",
        },
        compare: {
            title: "比較市場",
            pickMarket: "選擇市場",
            emptyHint: "新增市場以進行比較",
            totalCompanies: "已追蹤公司",
            readyToContact: "可聯繫(拓展)",
            newThisMonth: "本月新增轉換",
            aheadOfPace: "進度超前(30天)",
            stageBreakdown: "階段分布",
            expandingShareLabel: "可聯繫",
            viewMarket: "檢視此市場",
            viewMarketAction: "檢視",
            addColumn: "新增市場",
            removeColumn: "移除此市場",
            metricHeader: "指標",
            deltaHeader: "Δ",
            winnerBadgeTitle: "所選市場中最高",
            lensLabel: "比較方式",
            lensVolume: "總計",
            lensShare: "佔比 %",
            lensShareHint: "各指標佔該市場已追蹤公司的百分比",
            insightTitle: "這代表什麼",
            insightOverall: "{winner} 在 {total} 項指標中有 {n} 項領先。",
            insightExpanding: "{winner} 目前比 {loser} 多 {n} 家可聯繫公司。",
            insightMomentumMultiple: "{winner} 本月新增公司的速度是 {loser} 的 {multiple} 倍。",
            insightMomentumAbsolute: "{winner} 本月新增 {n} 家公司,而 {loser} 沒有新增。",
            insightPace: "{market} 有 {n} 家公司發展速度超越常態,值得進一步關注。",
            insightAboveWeight: "{winner} 表現超乎規模 — 其市場有 {winnerPct} 可聯繫,相較 {larger} 為 {largerPct}。",
            dimExpanding: "可聯繫",
            dimNewThisMonth: "本月新增",
            dimAheadOfPace: "領先進度",
            dimTotal: "已追蹤總數",
            dimTotalShare: "所選佔比",
            drillCellTitle: "開啟 {country}",
            drillCellTitleStage: "開啟 {country} — {stage} 階段",
            drillSegTitle: "開啟 {country} — {stage}({n} 家公司)",
            viewCrossMarket: "於 {n} 個市場中搜尋",
            summaryWinner: "{winner} 比 {loser} 多 {n} 家可聯繫公司。",
            summaryTie: "兩個市場的可聯繫公司數量相同。",
        },
        countryPicker: {
            title: "新增市場",
            searchPlaceholder: "搜尋國家名稱或代碼…",
            noMatch: "找不到符合的國家。",
        },
        stageTiles: {
            title: "階段分布",
            subtitle: "點選階段以篩選下方清單",
            ariaLabel: "擴張階段",
            bestToReachOut: "最佳聯繫時機",
            signalsHeading: "我們關注的訊號",
            signalSoon: "即將",
            infoAria: "此階段如何判定",
        },
        stage: {
            exploring: "探索",
            exploringDescription: "正在初步評估",
            committing: "投入",
            committingDescription: "正在投入實際資源",
            expanding: "拓展",
            expandingDescription: "正在深化當地布局",
            scaling: "規模化",
            scalingDescription: "正在擴大當地規模",
        },
        signal: {
            ad: "地區導向廣告",
            event: "參與會議",
            news: "新聞 / 公關",
            dns: "雲端足跡",
            dnsInsight: "偵測到此市場的雲端基礎設施。",
            tech: "產品在地化",
            infra: "資本投資",
            ip: "商標 / 專利",
            partner: "合作夥伴",
            eventPlus: "參展 / 演講",
            reg: "法規許可",
            entity: "法人登記",
            exec: "高階主管聘任",
            office: "辦公室租賃",
            hire: "在地團隊招募",
            scale: "人力擴編",
            product: "產品發布",
        },
        signalTier: {
            premier: "頂級",
        },
        direction: {
            advancing: "推進中",
            steady: "穩定",
            retreating: "撤退",
            new: "新增",
        },
        freshness: {
            fresh: "新鮮",
            cooling: "降溫中",
            stale: "陳舊",
            cold: "冷卻",
        },
        filters: {
            title: "篩選",
            clearAll: "全部清除",
            direction: "趨勢方向",
            freshness: "新鮮度",
            employees: "員工數",
            industry: "產業",
            risk: "風險",
            stage: "階段",
            scope: "範圍",
            founded: "成立年份",
            signalStrength: "訊號強度",
            signalVolume: "訊號數量",
            momentum: "動能",
            momentumAccelerating: "加速中",
            momentumAdvancing: "推進中",
            momentumSteady: "穩定",
            momentumPullingBack: "回落中",
            signalVolumeAny: "全部",
            signalVolumeWord: "訊號",
            onlyAtRisk: "僅顯示風險市場",
            any: "任何",
            employeesCustomRange: "自訂範圍",
            predefinedRange: "預設範圍",
            employeesPlaceholder: "選擇規模範圍",
            industrySubCategory: "子產業",
            industryCategory: "產業類別",
            industrySubCategoryPlaceholder: "輸入子產業",
            industryCategoryPlaceholder: "輸入產業類別",
            foundedRange: "成立年份",
            foundedFrom: "起始",
            foundedTo: "截止",
            min: "最小",
            max: "最大",
            // TODO: translate (placeholders copied from en.js)
            signalType: "信號類型",
            pace: "節奏",
            onlyAheadOfPace: "僅顯示領先節奏",
            paceHint: "從首個信號到最新階段變化的耗時處於該國最快四分位的公司。",
            searchPlaceholder: "搜尋篩選…",
            presets: "篩選預設",
            presetsSavedCount: "已儲存 {n} 個",
            activeOne: "{n} 個篩選生效中",
            activeMany: "{n} 個篩選生效中",
            moreChips: "+{n} 更多",
            lessChips: "收起",
            save: "儲存",
            clearShort: "清除",
            groupScope: "範圍",
            groupSignal: "擴張信號",
            groupSources: "訊號來源",
            route: "市場",
            routeFrom: "從",
            routeTo: "到",
            routeAnywhere: "任意地區",
            routeToOneWay: "切換為雙向",
            routeToEither: "切換為單向",
            routeOneWayLabel: "單向",
            routeEitherLabel: "雙向",
            routeSummaryEmpty: "任意地區",
            routeLoopNote: "{market} 同時出現在「從」和「到」中。擴張路線皆為跨境，因此不會有任何結果。",
            routeLoopKeepFrom: "保留 {code} → 任意地區",
            routeLoopKeepTo: "保留 任意地區 → {code}",
            routeInFromTag: "已在「從」",
            routeInToTag: "已在「到」",
            routeExclude: "排除目的地",
            groupCompany: "公司資料",
            date: "日期",
            markets: "進入 · 目標市場",
            flowDirection: "流向",
            marketsPlaceholder: "擴張到哪裡（目的地）",
            noMatchingFilters: "沒有符合的篩選",
            addFilter: "新增篩選",
            groupRecent: "最近",
            groupSuggested: "推薦",
            savedViews: "已儲存的篩選",
            savedViewsCount: "已儲存 {n} 個",
            noSavedViews: "尚無已儲存的篩選。",
            saveCurrentView: "儲存目前篩選",
            deleteView: "刪除篩選",
            deleteConfirm: "刪除",
            cancel: "取消",
            confirmDeleteView: "確定刪除已儲存的篩選「{name}」嗎？",
            saveDialogTitle: "儲存篩選",
            namePrompt: "為該篩選命名，方便日後調用。",
            namePlaceholder: "例如：熱門歐洲 SaaS",
            nameRequired: "請填寫篩選名稱。",
            location: "來自 · 公司總部",
            revenue: "營收",
            revenueRange: "年度營收（美元）",
            revenueMin: "最小（$）",
            revenueMax: "最大（$）",
            revenueHint: "來自增強資料的預估年度營收區間。",
            specialties: "專長",
            specialtiesPlaceholder: "搜尋專長…",
            technologies: "技術",
            technologiesPlaceholder: "搜尋技術…",
            companies: "公司",
            companiesPlaceholder: "搜尋公司…",
            activeTitle: "生效中",
            activeEmpty: "沒有生效的篩選",
            dateChipPrefix: "日期",
            marketChipPrefix: "市場",
            savedListChip: "已儲存清單",
            savedListFilterNote: "每家公司依其達到的最高階段顯示一列。階段圖塊與清單數量一致。",
            originChipPrefix: "來自",
            targetChipPrefix: "進入",
            removeFilter: "移除 {label}",
          stageDesc: "公司在該市場的活躍程度 — 從首個信號到規模化擴張。",
          momentumDesc: "擴張的趨勢方向 — 加速、穩定或回落。",
          signalVolumeDesc: "我們偵測到的擴張信號數量。信號越多，活動越活躍。",
          signalTypeDesc: "信號的種類 — 招募、廣告、新辦公室、新聞等。",
          freshnessDesc: "最新信號的新鮮程度。",
          scopeDesc: "進入全新市場，或深耕既有市場。",
          signalTypeUnavailable: "即將推出 — 該信號暫不可用",
          excludeMarkets: "排除市場",
          excludeMarketsPlaceholder: "要排除的市場…",
          excludeOrigins: "排除出發地",
          excludeOriginsPlaceholder: "要排除的出發地",
          excludeIndustry: "排除行業",
          excludeIndustryPlaceholder: "要排除的行業…",
        },
        scope: {
            enteringNewMarket: "進入新市場",
            expandingWithinPresence: "在現有據點內擴張",
            establishedOnly: "僅已建立據點",
        },
        signalStrength: {
            high: "高可信度",
            medium: "中等",
            low: "低",
        },
        row: {
            employees: "員工",
            marketsCount: "{n} 個市場",
            marketsActiveIn: "活躍於 {list}",
            founded: "成立",
            journey: "歷程",
            journeyLabel: "歷程",
            contractionFlag: "{days} 天內無新訊號。此公司可能正暫停或退出擴張。",
            noSignalsInDays: "{days} 天內無新訊號。此公司可能正暫停或退出擴張。",
            movingFast: "快速發展",
            movingFastDetail: "{months} 個月內歷經 {stages}。",
            addToSequence: "加入序列",
            saveToList: "儲存至清單",
            viewProfile: "檢視檔案",
            viewSignalsHint: "點選以檢視所有訊號",
            signalCount: "{n} 個訊號",
            distinctTypes: "{n} 種訊號類型",
            stageUpInDays: "階段升級 · {days} 天前",
            stageUpToday: "階段升級 · 今天",
            newInDays: "新增 · {days} 天",
            newToday: "新增 · 今天",
            selectRow: "選擇公司",
            lastSignal: "最近訊號",
            // TODO: translate (placeholders copied from en.js)
            contractionFlag_leading: "Early signs of contraction — multiple leading indicators (exec departures, layoff chatter) in the last 60 days.",
            contractionFlag_confirming: "Recent contraction signal — a layoff or downsizing was reported in the last 180 days.",
            contractionFlag_lagging: "Confirmed retreat — a market exit, office closure or de-registration in the last 12 months.",
            contractionFlag_leading_mixed: "Mixed signals — early contraction indicators alongside ongoing expansion activity. Watch closely.",
            contractionFlag_confirming_mixed: "Mixed signals — a recent contraction signal sits alongside fresh expansion activity. Confidence is split; review before acting.",
            stageOf: "Stage {n} of {total}",
            tooltipDirection_advancing: "Moved up at least one stage in the last 30 days",
            tooltipDirection_steady: "No stage change in the last 30 days",
            tooltipDirection_retreating: "Fewer recent signals — this company may be pulling back from this market",
            tooltipDirection_new: "Just appeared as a potential expander",
            tooltipFreshness_fresh: "Last signal in the past 30 days",
            tooltipFreshness_cooling: "Last signal 30 to 60 days ago",
            tooltipFreshness_stale: "Last signal 60 to 90 days ago — activity has cooled",
            tooltipFreshness_cold: "No signals in the past 90 days",
            tooltipSignalCount: "Total expansion signals tracked for this company ({n})",
            tooltipDistinctTypes: "{n} different kinds of signal (hiring, news, office lease, etc.)",
            tooltipStageUp: "Recently moved up to the {stage} stage",
            tooltipNew: "First signal detected recently",
            tooltipSignalType: "Signal type: {type}",
        },
        list: {
            title: "{count} 家公司",
            titleAll: "{country} 的 {count} 家公司",
            titleAllGlobal: "所有市場共 {count} 家公司",
            titleStageScoped: "{country} — {stage} 階段的 {count} 家公司",
            titleStageScopedGlobal: "所有市場 — {stage} 階段的 {count} 家公司",
            filteredBy: "篩選條件",
            export: "匯出",
            previous: "上一頁",
            next: "下一頁",
            pageOf: "第 {page} 頁,共 {total} 頁",
            selectAll: "全選",
            sortLabel: "排序",
            sortRelevance: "相關度",
            sortRecent: "最新",

            selectAllOption: "全部",
            selectThisPage: "本頁",
            selectCustomize: "自訂",
            selectHint: "於目前檢視中最多可選擇 {count} 家公司。",
            applySelection: "套用",
            selected: "已選 {n} 項",
            bulkSequence: "加入序列",
            bulkSave: "儲存至清單",
            bulkExport: "匯出已選",
            findPeople: "尋找聯絡人",
            clearSelection: "清除",
            paceHint: "{country} 從探索 → 拓展的中位數為 6 個月。有 {n} 家公司領先進度。",
            movingFast: "快速發展",
            movingFastDetail: "4 個月內從探索 → 規模化。{country} 的 SaaS 中位數為 6 個月。",
            emptyTitle: "目前尚無符合此檢視的公司。",
            emptyBody: "請嘗試其他市場,或等待新訊號到達。",
            emptyStageTitle: "目前此階段無公司。",
            emptyStageBody: "請選擇其他階段繼續探索。",
            emptyRouteTitle: "此期間內沒有 {from} → {to} 的動向。",
            emptyRouteBody: "放寬路線的一端，或延長日期範圍。",
            emptyLoopTitle: "市場無法向自身擴張。",
            emptyLoopBody: "{market} 位於路線兩端。保留一端並放開另一端，即可檢視跨境動向。",
            emptyRouteKeepFrom: "{code} → 任意地區",
            emptyRouteKeepTo: "任意地區 → {code}",
            pickCountryTitle: "請選擇國家以開始。",
            pickCountryBody: "點選上方市場標籤(或使用地圖)以鎖定儀表板範圍。",
        },
        map: {
            topSectors: "主要產業",
            expandingInto: "擴張進入",
            comingFrom: "來自",
            placeholderAriaLabel: "擴張世界地圖",
            loadingBasemap: "載入底圖中…",
            loadingCountry: "載入市場資料中…",
            loadingDashboard: "載入擴張資料中…",
            newThisMonthIn: "{country} 本月新增",
            newTransitionsAllMarkets: "本月新增轉換",
            readyToContact: "可聯繫",
            tracked: "已追蹤總數",
            activeMarkets: "活躍市場",
            ctaReadyToContact: "檢視 {n} 家可聯繫公司",
            origins: {
                title: "主要來源地 → {country}",
                total: "{n} 筆跨境",
                domestic: "+{n} 筆境內({country} → {country})",
                untracked: "+{n} 筆來源尚未追蹤",
                empty: "此市場尚無來源地資料。",
                plusMore: "+{n} 個更多來源",
                clearFilter: "清除來源篩選",
            },
            timeFilterLabel: "顯示訊號自",
            timeFilterToday: "今天",
            timeFilterWeek: "本週",
            timeFilterMonth: "本月",
            timeFilterAll: "全部時間",
            activityFeedTitle: "最新動態",
            activityFeedEmpty: "所選期間內無新動態。",
            activityFeedFooter: "檢視所有動態 →",
            activityFeedAdvanced: "已進入 {stage}",
            activityFeedNew: "偵測到新訊號",
            activityFeedFrom: "來自{country}",
            activityFeedTitleHint: "點擊查看公司詳情",
            activityFeedTitleHintCountry: "點擊聚焦此市場",
            marketIntelTitle: "市場情報",
            tabOrigins: "主要來源地",
            tabWhatsNew: "最新動態",
            tabActivity: "剛剛異動",
            whatsNewAriaLabel: "市場動態洞察",
            whatsNewLoading: "正在計算…",
            whatsNewEmpty: "所選時段暫無異動。請在地圖控件中調整時間範圍。",
            whatsNewMovesLabel: "次本期異動",
            whatsNewVsPrev: "對比{label} {n} 次",
            whatsNewPrevDay: "昨日",
            whatsNewPrevWeek: "上週",
            whatsNewPrevMonth: "上月",
            whatsNewPrevDays: "過去 {n} 天",
            whatsNewHotCorridors: "熱門走廊",
            whatsNewSurgingDestinations: "目的地激增",
            whatsNewSurgingOrigins: "來源激增",
            whatsNewStageVelocity: "階段速度",
            whatsNewNotableMovers: "重點動態",
            whatsNewDeltaNew: "新",
            whatsNewDeltaFlat: "持平",
            whatsNewCorridorHint: "篩選列表為 {from} → {to}",
            whatsNewDestinationHint: "聚焦 {country} 市場",
            whatsNewOriginHint: "篩選來自 {country} 的公司",
            whatsNewStageHint: "篩選 {stage} 階段",
            whatsNewScopeGlobal: "全部市場",
            whatsNewScopeMulti: "{n} 個市場",
            whatsNewWindowToday: "今日",
            whatsNewWindowWeek: "近 7 天",
            whatsNewWindowMonth: "近 30 天",
            whatsNewWindowDays: "近 {n} 天",
            whatsNewViewAll: "查看列表中所有公司",
            whatsNewViewAllN: "查看全部 {n} 家公司",
            whatsNewWhereFrom: "主要來源地",
            whatsNewPipelineMix: "階段分佈",
            whatsNewCaptionGlobal: "全部市場動態 · {window}",
            whatsNewCaptionCountry: "進入 {country} 的動態 · {window}",
            whatsNewCaptionMulti: "{n} 個市場動態 · {window}",
            whatsNewTabForYou: "為你篩選",
            whatsNewTabFastMovers: "快速進展",
            whatsNewTabWideExpanders: "全面擴張",
            whatsNewWideExplainer: "近期同時進入 3 個以上新市場的公司 — 多國並行擴張。",
            whatsNewWideEmptyTitle: "此範圍內暫無全面擴張的公司",
            whatsNewWideEmptyBody: "嘗試擴大時間範圍或清除國家篩選，以查看同時進入多個市場的公司。",
            whatsNewMarketsCount: "{n} 個新市場",
            whatsNewMarketsInlineMore: "另有 {n} 個",
            whatsNewFoundedYear: "成立於 {year}",
            whatsNewOpenList: "開啟清單：{name}",
            whatsNewForYouExplainer: "您儲存的公司清單中,在此時間範圍內有新進展的清單。",
            whatsNewForYouEmptyTitle: "您的清單暫無新動向",
            whatsNewForYouEmptyBody: "您儲存的公司在此時間範圍內尚未發生階段變化。請擴大時間範圍或稍後再查看。",
            whatsNewUnnamedList: "未命名清單",
            whatsNewListCount: "{n} 家公司",
            whatsNewListUpdated: "更新於 {time}",
            whatsNewSavedListMovers: "{count} 家有新動向",
            whatsNewSavedListMoversAriaLabel: "此清單有 {count} 家公司有新動向",
            whatsNewSavedListTotal: "共 {total} 家",
            whatsNewFastMoversTitle: "進展超前的公司",
            whatsNewFastEmptyTitle: "此範圍內暫無快速進展公司",
            whatsNewFastEmptyBody: "嘗試擴大時間範圍或清除國家篩選，以查看進展超前的公司。",
            whatsNewFastExplainer: "進展快於市場 75% 同行的公司。",
            whatsNewMovingFastDetail: "{from} → {to}，{months} 個月內",
            whatsNewStageUpAt: "階段提升 · {time}",
            whatsNewViewList: "查看完整公司清單",
            whatsNewMarketsChip: "已進入 {n}+ 個市場",
            whatsNewVerbInto: "進入 {scope}",
            whatsNewVerbAcross: "跨境動態",
            whatsNewVelocityTitle: "本期 {n} 家公司{verb}",
            whatsNewVelocityDetail: "上一{window}為 {previous} 家",
            whatsNewVelocityDetailNoPrior: "首次出現有效活動",
            whatsNewStoryNew: "{from} → {to} 是本期新走廊",
            whatsNewStoryNewDetail: "{n} 家公司剛完成遷移 — 首次記錄到此走廊",
            whatsNewStorySurge: "{from} → {to} 激增 {delta}%",
            whatsNewStoryCool: "{from} → {to} 降溫 {delta}%",
            whatsNewStoryDeltaDetail: "本期 {current} 次 vs 上一期 {previous} 次",
            whatsNewStoryStageUp: "{stage} 階段上升 {delta}%",
            whatsNewStoryStageDown: "{stage} 階段下降 {delta}%",
            whatsNewStoryStageDetail: "{n} 家公司剛進入 {stage}",
            whatsNewStoryMover: "{company} 剛進入 {stage}",
            showActivity: "顯示市場情報",
            hideActivity: "隱藏市場情報",
            windowEmptyBody: "擴大日期範圍以顯示該公司的活動。",
      noActivityTitle: "此檢視中尚無變動。",
            noActivityBody: "請選擇其他市場或切換至全球流向。",
            noOutgoingTitle: "{country} 尚無對外擴張訊號",
            noOutgoingBody: "目前資料中尚未偵測到任何從 {country} 對外擴張的公司。請嘗試切換至已選市場檢視,以查看哪些公司正進入此國家。",
            noOutgoingCta: "檢視進入此市場的公司",
            companiesCount: "{n} 家公司 | {n} 家公司",
            newThisMonthCount: "本月新增 {n} 家",
            clickHint: "將游標移至市場以檢視詳情 · 點選以深入查看",
            zoomIn: "放大",
            zoomOut: "縮小",
            resetView: "重設檢視",
            densityShowN: "最多 {n} 個市場 | 最多 {n} 個市場",
            densitySliderAriaLabel: "地圖密度 — 滑動以顯示更多或更少來源地",
            legendAriaLabel: "地圖圖例",
            legendTitle: "階段",
            legendSectionRecent: "近期動態",
            legendStageUp: "推進中",
            legendStageUpTitle: "青色環標示近 30 天內階段升級的國家",
            legendNew: "新增",
            legendNewTitle: "發光點標示近 90 天內展開擴張的國家",
            legendBadge30d: "30 天",
            legendBadge90d: "90 天",
            legendCollapse: "最小化圖例",
            legendExpand: "顯示圖例",
            companies: "家公司",
            // TODO: translate (placeholders copied from en.js)
            activityFeedEmptyGlobal: "Pick a market above to see companies that just moved stages.",
        },
        tooltip: {
            signals: "訊號",
            companiesMoving: "家公司正在異動",
            companiesExpandingFrom: "家公司由此擴張",
            companiesArrivingAt: "家公司由此來源進入",
            clickToScope: "點擊篩選列表 →",
        },
        popover: {
            close: "關閉",
            loading: "載入詳情中…",
            loadFailed: "無法載入此市場。",
            keyMoments: "關鍵時刻",
            signals: "訊號({n})",
            firstSignal: "首個訊號",
            latestSignal: "最近訊號",
            reachedStage: "已達到 {stage}",
            stageUp: "階段升級",
        },
        drawer: {
            title: "公司擴張檔案",
            currentStage: "目前階段",
            confidence: "可信度",
            confidenceHigh: "高",
            confidenceMedium: "中",
            confidenceLow: "低",
            signalGeneric: "訊號",
            allSignals: "訊號時間軸",
            signalsCount: "{n} 個訊號",
            noSignals: "此市場配對尚未擷取任何詳細訊號。",
            contractionBanner: "偵測到收縮訊號 — 聯繫前請確認此公司是否仍在擴張。",
            openFullProfile: "開啟完整檔案",
            visitWebsite: "造訪網站",
            // Expansion context (route between hero card and stage strip)
            expandingInto: "擴張進入",
            expandingFrom: "來自",
            expansionTo: "擴張至",
            signalsInMarket: "訊號於",
            // Company overview tile
            companyAtAGlance: "公司一覽",
            industry: "產業",
            founded: "成立",
            employees: "員工",
            headquarters: "總部",
            website: "網站",
            // Presence section
            onTheGround: "在地據點",
            presenceOffice: "辦公室",
            presenceLegal: "法人實體",
            presenceHiring: "招募中",
            // TODO: translate
            milestoneActiveRoles: "Reached {n} active role | Reached {n} active roles",
            milestoneScale: "Reached open-roles threshold",
            // Other markets
            alsoExpandingTo: "同時擴張至",
            noOtherMarkets: "尚未偵測到其他市場。",
            showAll: "顯示全部({n})",
            showLess: "顯示較少",
            filterAll: "全部",
            // Pace
            paceLabel: "擴張速度",
            paceText: "從首個訊號到 {stage} 共 {days} 天",
            paceFast: "快速",
            paceTypical: "一般",
            paceSlow: "緩慢",
            localTeamLabel: "本地團隊",
            lastActiveLabel: "最近活動",
            teamPeople: "人",
            localTeamNone: "無",
            localTeamNetNew: "全新市場",
            localTeamEmerging: "初步佈局",
            localTeamEstablished: "已進駐",
            localTeamNoData: "—",
            localTeamNoDataMeta: "無本地資料",
            localTeamOnSite: "已駐點",
            readScalingTitle: "擴張現有團隊",
            readScalingDetail: "已在{market}扎根——近期招聘與廣告是在擴張現有的本地業務，而非全新進入。",
            readDeepeningTitle: "深化本地佈局",
            readDeepeningDetail: "已在{market}扎根並持續加碼——是在擴張現有業務，而非首次進入。",
            readSteadyTitle: "本地營運中",
            readSteadyDetail: "已在{market}扎根，本地活動持續穩定。",
            readEstablishingTitle: "正在建立據點",
            readEstablishingDetail: "已在{market}有小團隊——近期訊號顯示正在擴充。",
            paceInMarket: "已在本地",
            thisMarket: "該市場",
            readAxesFootnote: "階段反映近期動態 · 團隊反映規模——兩者可能不同。",
            teamFoundDetail: "在{market}已找到 {n} 人——實際可能更多。",
            // Signal labels
            signalSource: "透過 {source}",
            signalTierHint: "難以取得的情報，由 Pubrio 發掘呈現",
            signalSurfacedByPubrio: "由 Pubrio 發現",
            signalSourceFrom: "透過 {source} · {host}",
            signalViewSource: "檢視來源",
            signalNoEvidence: "無可用的來源連結",
            // Footer note
            poweredBy: "最近偵測到的訊號",
            // TODO: translate (placeholders copied from en.js)
            signalsCountOf: "{n} of {total} signals",
            loadMore: "Load more signals",
            switchMarket: "Switch market",
            durationDays: "{n}d",
            durationWeeks: "{n}w",
            durationMonths: "{n}mo",
            durationYears: "{n}y",
            reachedStageAt: "Reached {stage} {when}",
            transitionDuration: "{duration} in {prev}",
            signalGroupTitle: "{n} × {type}",
            signalGroupContext: "{items}",
            headcountScalingTitle: "{n} jobs currently open",
            recentSignalsChip: "{n} {type} · 12w",
            activityLabel: "Activity",
            activityWindow: "{weeks} weeks",
            activityTotal: "All",
            activityFilterByType: "Filter timeline to {type}",
            activityCellTooltip: "{n} × {type} · {week}",
            activityCellMore: "+{n} more",
            activityCellEmpty: "No {type} signals · {week}",
            activityEmpty: "Quiet for now",
            activityEmptyHint: "No signals detected in the last 12 weeks — this company's expansion engine is paused or pre-launch.",
            snapshotLabel: "Current snapshot",
            showItems: "Show {n}",
            showItemsOf: "Show {n} of {total}",
            dnsServers: "{n} 台伺服器",
            hideItems: "Hide",
            loadingMore: "Loading…",
        },
        live: {
            title: "市場動態",
            live: "即時",
            all: "全部",
            advancing: "推進中",
            retreating: "撤退",
            tabNews: "新聞",
            tabFunding: "募資情報",
            tabJobs: "職缺刊登",
            tabAds: "廣告",
            sort: "排序",
            sortNewest: "最新優先",
            sortOldest: "最舊優先",
            sortImpact: "影響力",
            filter: "篩選",
            findPeople: "尋找人員",
            searchPlaceholder: "搜尋 …",
            pendingBanner: "自上次造訪後有 {n} 則新文章 · 點選載入",
            empty: "目前尚無轉換 — 公司異動時將顯示於此。",
            lastHour: "最近一小時",
            advanced: "已晉升至",
            retreated: "已撤退自",
            decayed: "已衰退自",
            changed: "已轉換至",
        },
        trending: {
            title: "熱門公司",
            mostActiveToday: "今日最活躍",
            catAll: "全部",
            catTechnology: "科技",
            catFintech: "金融科技",
            catHealthcare: "醫療保健",
            catSaaS: "SaaS",
            more: "更多",
            empty: "目前尚無熱門公司。",
        },
        toast: {
            sequenceQueued: "已開啟加入序列 — 請於彈出視窗中選擇序列。",
            savedToList: "已將 {name} 儲存至您的清單。",
            saveFailed: "無法儲存至清單。請重試。",
            exportReady: "已匯出 {n} 筆資料。",
            exportFailed: "匯出失敗 — 請嘗試較小批次。",
        },
        export: {
            title: "匯出擴展資料為 CSV",
            body: "匯出 {count} 筆資料為 CSV 將使用 {price} 點數。",
        },
        watch: {
            cta: "關注此檢視",
            ctaShort: "關注",
            watching: "關注中",
            newCount: "{n} 筆新增",
            cadenceHeading: "提醒方式",
            start: "開始關注",
            recommended: "推薦",
            update: "更新監控",
            realtime: "即時",
            realtimeDesc: "每當有訊號出現",
            daily: "每日摘要",
            dailyDesc: "每天一次彙整",
            weekly: "每週摘要",
            weeklyDesc: "每週一彙整",
            statusActive: "已啟用",
            statusPaused: "已暫停",
            newMatches: "新符合項目",
            lastChecked: "上次檢查",
            never: "尚未執行",
            frequency: "頻率",
            scope: "範圍",
            scopeSummary: "{market} · {n} 個篩選條件",
            allMarkets: "所有市場",
            viewMatches: "檢視符合項目",
            pause: "暫停",
            resume: "恢復",
            stop: "停止關注",
            namePlaceholder: "為此監控命名",
            defaultName: "{market} · 擴展訊號",
            monitorName: "{market} · 擴展訊號 #{date}",
            created: "關注中 — 有新訊號時將通知你",
            updated: "監控已更新",
            stopped: "已停止關注",
            paused: "監控已暫停",
            resumed: "監控已恢復",
            viewChanged: "篩選條件已變更 — 請更新你的監控",
            empty: "新增市場或篩選條件以關注此檢視",
        },
        widgetRail: {
            title: "更多小工具",
            expandHint: "點選以展開",
        },
        errors: {
            loadFailed: "無法載入擴張資料。",
            retry: "重試",
        },
        time: {
            unknown: "—",
            today: "今天",
            daysAgo: "{n} 天前",
            weeksAgo: "{n} 週前",
            monthsAgo: "{n} 個月前",
            yearsAgo: "{n} 年前",
        },
    },

    // TODO: translate (placeholders copied from en.js)
    exportingLeadsToACSV: "Exporting leads to a CSV will use {count} credit. | Exporting leads to a CSV will use {count} credits.",
};